"use strict";

define('evisions/helper/form',['underscore', 'jquery'], function (_, $) {
  var EVIHelperForm = _.extend({
    formToJSON: function formToJSON(selector) {
      var data = {};
      $.map($(selector + ' :input').serializeArray(), function (x, y) {
        data[x['name']] = x['value'];
      });
      return JSON.stringify(data);
    }
  });
  return EVIHelperForm;
});

